import { z } from 'zod'

export const AGENTMCP_TRANSPORT_CONTRACT_VERSION = '1.0.0' as const

export const agentmcpJsonRpcRequestSchema = z.object({
  jsonrpc: z.literal('2.0'),
  id: z.union([z.string(), z.number(), z.null()]),
  method: z.string().min(1),
  params: z.record(z.unknown()).optional(),
}).passthrough()

export const agentmcpJsonRpcResponseSchema = z.object({
  jsonrpc: z.literal('2.0'),
  id: z.union([z.string(), z.number(), z.null()]),
}).passthrough()

export type AgentmcpJsonRpcRequest = z.infer<typeof agentmcpJsonRpcRequestSchema>
export type AgentmcpJsonRpcResponse = z.infer<typeof agentmcpJsonRpcResponseSchema>
